<template>
<div id="wrap" class="full_wrap"><!-- GNB/Footer 없을때 -->
    <!-- container -->
    <div id="container">
        <div class="container_wrap">
            <!-- logout -->
            <div class="logout_item">
                <p>
                    You have successfully logged out.
                </p>
            </div>
            <!-- //logout -->
        </div>
    </div>
    <!-- //container -->
</div>
</template>
<script>
import Vue              from 'vue';
import { mapActions }   from 'vuex';
import store            from '@/vuex/store';
import MenuUtil         from '@/utils/MenuUtil';
import SDLUtil          from '@/utils/SDLUtil';

const command = MenuUtil.getMoveKeyDownCode;

export default {
    data() {
        return {
            isVisible: false
        };
    },
    methods: {
        ...mapActions(['logout']),
        goMain() {
            // this.$router.push({ name : 'Login' });
            document.location = `${SDLUtil.WEB_CONTEXT_PATH}/Sensp560`;
        }
    },
    created() {
        const that = this;
        this.logout();

        let kkeys = [];
        $(document).keydown(function(e) {
            kkeys.push( e.keyCode );
            if(
                    kkeys.toString().indexOf( command ) >= 0
                 || (
                        /* 로컬, 개발에서는 엔터 3번으로 로그인화면 이동 */
                        ( process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'dev' )
                     && kkeys.toString().indexOf( "13,13,13" ) >= 0
                    )
            ) {
                kkeys = [];
                // store.commit('CONN_SYSTEM', 'DIRECT');
                that.goMain();
            }
        });

    },
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/login/Logout.vue